module.exports = __webpack_public_path__ + "assets/img/activity-time-915670f0.png";